// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"0f85c699","174":"aabbe55b","453":"9318896a","541":"d1a21c02","561":"fd985f7b","597":"9577620d","614":"704cd7d3","677":"ddd02ad4","779":"f2e273cc","802":"25987ffa","865":"742a801a","892":"9dfaf10a","937":"3242470b","971":"55eb9a30"}[chunkId] + ".chunk.js";
};